import React, { useState, useEffect, useRef } from "react";
import EquipmentService from "../../../services/equipment";
import MaintenanceService from "../../../services/maintenance";
import ReportService from "../../../services/report";
import EquipmentTypeService from "../../../services/equipment-type";
import SpinnerLoad from "../../components/Main/SpinnerLoad/SpinnerLoad";
import SelectMain from "../../components/Main/SelectMain";
import BodyMaintenance from "../../components/Maintenance/BodyMaintenance";
import InputMain from "../../components/Main/InputMain";
import { filterData, signOut, validateUser } from "../../../utils/function";
import { simpleAlerts } from "../../../utils/alerts";
import { CODES } from "../../../utils/httpCodes";
import { pathRoute } from "../../config/routesFiles";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import excelImg from "../../../assets/icons/excel.png";
import BodyGenerateMaintenance from "../../components/Maintenance/BodyGenerateMaintenance";

const Maintenance = () => {
  const url = window.location.pathname;
  const [titleLoad, setTitleLoad] = useState("Carga Inicial ...");
  const [openLoad, setOpenLoad] = useState(true);
  const handleOpenLoad = () => setOpenLoad(true);
  const handleCloseLoad = () => setOpenLoad(false);
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [equipmentType, setEquipmentType] = useState(null);
  const [valueEquipmentType, setValueEquipmentType] = useState(null);
  const [filtrar, setFiltrar] = useState(null);
  const [tiposMantenimiento, setTiposMantenimiento] = useState([]);


  const [equipment, setEquipment] = useState(null);
  const [dataEquipment, setDataEquipment] = useState(null);
  const [dataFilter, setDataFilter] = useState(null);
  const [searchS, setSearchS] = useState("");
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const pageSize = 20;
  const [totalPages, setTotalPages] = useState(1);

  let resultSearch = filterData(dataFilter, searchS, [
    "nombre",
    "nroSerie",
    "imei",
  ]);

  const [selectedItems, setSelectedItems] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  const [maintenanceEquip, setMaintenanceEquip] = useState(null);

  const [activeTab, setActiveTab] = useState(0);
  const [edit, setEdit] = useState(0);

  const fileInputRef = useRef(null);
  useEffect(() => {
    setDataEquipment(null);
  }, [valueEquipmentType, search]);

  useEffect(() => {
    init();
  }, []);

  useEffect(() => {
    getEquipment();
  }, [page]);

    useEffect(() => {
      getMaintenanceTypes();
    }, []);

  const init = async () => {
    Promise.all([
      getEquipmentType(),
      getEquipment(),
    ]).then(() => {
      handleCloseLoad();
      setTitleLoad(null);
    });
  };

   const getMaintenanceTypes = async () => {
    try {
      const result = await MaintenanceService.getMaintenanceTypes(url);
      if (result.status === CODES.SUCCESS_200) {
        const data = result.data.map((e) => ({
          id: e.id_tipo_mantenimiento,
          value: e.id_tipo_mantenimiento,
          label: e.nombre
        }));
        setTiposMantenimiento(data);
      } else {
        simpleAlerts("No se encontró tipos de mantenimientos", "info");
      }
  
    } catch (error) {
      console.log(error);
      alert("Error buscando tipos de mantenimientos");
    }
  };

  const getEquipmentType = async () => {
    try {
      const result = await EquipmentTypeService.getEquipmentType(url);
      if (result.status === CODES.SUCCESS_200) {
        result.data?.forEach((element) => {
          element.id = element.id_tipoEquipo;
          element.label = element.desTipoEquipo;
          element.value = element.id_tipoEquipo;
        });
        let tmp = result.data;
        tmp.unshift({ id: -1, value: -1, label: "Todas" });
        setEquipmentType(tmp);
      }
      return [];
    } catch (error) {
      console.log(`Error en getProviders: ${error}`);
    }
  };

  const getEquipment = async () => {
    try {
      handleOpenLoad();
      setTitleLoad("Buscando equipos ...");
      const params = {
        tipoEquipo: valueEquipmentType,
        filtrar: filtrar,
      };
      const result = await EquipmentService.getEquipment(url, params, {
        search,
        page,
        pageSize,
        pagination: 1,
      });
      setDataEquipment(null);
      setTotalPages(null);

      if (result.status === CODES.SUCCESS_200) {
        setDataEquipment(result.data[0]);
        setTotalPages(result.data[1]?.totalPages);
      } else {
        simpleAlerts("No se encontró equipo", "info");
      }

      return [];
    } catch (error) {
      console.log(`Error en getEquipment: ${error}`);
    } finally {
      handleCloseLoad();
      setTitleLoad(null);
    }
  };

  const viewDetailEquipment = (info) => {
    setEquipment(info);
    handleOpen();
  };
  async function generateReport() {
    try {
      handleOpenLoad();
      setTitleLoad("Generando Reporte ...");

      // 1️⃣ Generar reporte en el backend
      const pathReport = await getReport();

      // 2️⃣ Espera opcional (puedes ajustar)
      await waiting(1000);

      // 3️⃣ Descargar el archivo
      await downloadReport(pathReport);

      // 4️⃣ Llamar al backend para eliminar el archivo del servidor
      const array = pathReport.split("/");
      const filename = array[array.length - 1];
      await fetch(`${pathRoute.path}/report/general-inventory/${filename}`, {
        method: "DELETE",
      });
    } catch (error) {
      console.error("Error en general:", error);
      simpleAlerts("Ocurrió un error al procesar la solicitud.", "error");
    } finally {
      handleCloseLoad();
      setTitleLoad(null);
    }
  }

  // Función de espera opcional
  function waiting(ms = 1000) {
    return new Promise((resolve) =>
      setTimeout(() => resolve("waiting..."), ms),
    );
  }

  // Función para generar reporte y recibir la ruta
  async function getReport() {
    try {
      const params = {
        tipoEquipo: valueEquipmentType,
      };

      const result = await ReportService.getReport(url, params, {
        search: search,
        page: page,
        pageSize: pageSize,
        pagination: 1,
      });

      if (result.status === CODES.SUCCESS_200) {
        return `${pathRoute.path}/reports/${result.data.file}`;
      } else {
        throw new Error("No se pudo generar el reporte.");
      }
    } catch (error) {
      console.error("Error en getReport:", error);
      throw error;
    }
  }

  // Función para descargar archivo
  const downloadReport = (rutaReport) => {
    return new Promise((resolve) => {
      const array = rutaReport.split("/");
      const nombre = array[array.length - 1];
      const link = document.createElement("a");
      link.setAttribute("href", rutaReport);
      link.setAttribute("download", nombre);
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      resolve(rutaReport);
    });
  };

  const handleTabClick = (tabIndex, event) => {
    event.preventDefault();
    setActiveTab(tabIndex);
    setEdit(tabIndex);
  };

const handleFileChange = async (e) => {
  const file = e.target.files[0];
  if (!file) return;
  try {
    handleOpenLoad();
    setTitleLoad("Subiendo archivo...");
    const result = await MaintenanceService.uploadMaintenanceExcel(url,file);
    if (result.status === CODES.SUCCESS_200) {
      simpleAlerts("Mantenimientos importados correctamente", "success");
    }
     handleClose();
  } catch (error) {
    console.log(error);
    simpleAlerts("Error subiendo archivo", "error");
  } finally {
    e.target.value = null;
     handleClose();
     setTitleLoad(null)
  }

};



  return (
    <div className="container">
      <ul className="nav nav-tabs nav-tabs-charge justify-content-center">
        <li className="nav-item">
          <a
            className={`nav-link ${activeTab === 0 ? "active" : ""}`}
            onClick={(e) => handleTabClick(0, e)}
            href="#"
          >
            Informes Mant.
          </a>
        </li>
       { /*<li className="nav-item">
          <a
            className={`nav-link ${activeTab === 1 ? "active" : ""}`}
            onClick={(e) => handleTabClick(1, e)}
            href="#"
          >
            Generar Mant.
          </a>
        </li>*/ }
      </ul>
      {activeTab === 0 ? (
        <div className="container">
          <div className="row">
            <div className="col-3">
              <SelectMain
                title={"Tipo"}
                placeholder={"Seleccionar tipo de equipo de busqueda"}
                options={equipmentType}
                value={valueEquipmentType || -1}
                onChange={(value, event) => setValueEquipmentType(value)}
              />
            </div>
            <div className="col-6">
              <div className="d-flex align-items-end">
                <InputMain
                  title={"Buscar equipo"}
                  placeholder={"Nro seria, nombre, código de barras"}
                  width={"100%"}
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
                <button
                  type="button"
                  className="btn btn-outline-light btn-group-custom"
                  onClick={() => getEquipment()}
                >
                  <i className="fa-solid fa-magnifying-glass"></i>
                </button>
              </div>
            </div>
            <div className="col d-flex justify-content-center justify-content-md-end align-items-end gap-3">
              <button
                type="button"
                className="btn btn-warning"
                title="Subir mantenimiento"
                onClick={() => fileInputRef.current.click()}
              >
                <UploadFileIcon />
              </button>
              <button
                type="button"
                className="btn btn-warning"
                title="Generar Reporte"
                //onClick={() => generateReport()}
              >
                <img src={excelImg} width={25} />
              </button>
            </div>
          </div>
          <BodyMaintenance
            handleOpenLoad={handleOpenLoad}
            handleCloseLoad={handleCloseLoad}
            setTitleLoad={setTitleLoad}
            getEquipment={getEquipment}
            data={dataEquipment}
            resultSearch={resultSearch}
            searchS={searchS}
            selectedItems={selectedItems}
            setSelectedItems={setSelectedItems}
            selectAll={selectAll}
            setSelectAll={setSelectAll}
            totalPages={totalPages}
            page={page}
            setPage={setPage}
            handleOpen={handleOpen}
            setMaintenanceEquip={setMaintenanceEquip}
            maintenanceEquip={maintenanceEquip}
            handleClose={handleClose}
            open={open}
            tiposMantenimiento={tiposMantenimiento}
            setTiposMantenimiento={setTiposMantenimiento} url={url}
          />
        </div>
      ) : (
        <div className="container">
          <div className="animate__animated animate__backInDown">
            <BodyGenerateMaintenance
              setTitleLoad={setTitleLoad}
              setActiveTab={setActiveTab}
              url={url}
              handleOpenLoad={handleOpenLoad}
              handleCloseLoad={handleCloseLoad}
              tiposMantenimiento={tiposMantenimiento}
              setTiposMantenimiento={setTiposMantenimiento}
            />
          </div>
        </div>
      )}
      <SpinnerLoad open={openLoad} title={titleLoad} />
      <input
        type="file"
        accept=".xlsx,.xls"
        ref={fileInputRef}
        style={{ display: "none" }}
        onChange={handleFileChange}
      />
    </div>
  );
};

export default Maintenance;
